<template>
    <div>
  <b-dropdown id="dropdown-1" text="Menú cadena" class="m-md-2">
     <h6 class="dropdown-header">BOVINOS</h6>
     <b-dropdown-item class="d-none d-sm-block d-md-block"><router-link to="/FacturaGuiaFOTO">Registro Origen de Bovinos</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/InicioUsuario">Registro Pesos</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/Trazabilidad">Trazabilidad Bovinos</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/SalidaCarne">Salida de Carne Bovino</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/Decomisos">Decomisos</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/QRPesos">Consulta de pesos</router-link></b-dropdown-item>
     <div class="dropdown-divider"></div>
    <h6 class="dropdown-header">PORCINOS</h6>
    <b-dropdown-item><router-link to="/FacturaGuiaPorcinosFOTO">Registro Origen de Porcinos</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/TrazabilidadPorcinos">Trazabilidad Porcinos</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/SalidaCarnePorcino">Salida de Carne Porcino</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/Decomisos">Decomisos</router-link></b-dropdown-item>
  <div class="dropdown-divider"></div>
    <h6 class="dropdown-header">REPORTES Y VALIDACIONES</h6>
    <b-dropdown-item><router-link to="/RevisarTrazabilidad">Revisión de trazavilidad</router-link></b-dropdown-item>
    
  </b-dropdown>
  <b-dropdown id="dropdown-1" text="Menú usuario" class="m-md-2">
    <b-dropdown-item><router-link to="/EditarPerfilUsuario">Editar Perfil</router-link></b-dropdown-item>
    <div class="dropdown-divider"></div>
    <h6 class="dropdown-header">HERRAMIENTAS</h6>
    <b-dropdown-item><router-link to="/RegistroBitacora">Registrar Bitácora</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/RevisarBitacora">Revisar Bitácora</router-link></b-dropdown-item>
    
  </b-dropdown>
  <b-dropdown id="dropdown-1" text="Menú vigilancia" class="m-md-2">
    <b-dropdown-item><router-link to="/RegistrarVehiculos">Registrar Vehículos</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/RegistrarPersonas">Registrar Personas</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/RegistrarFlujoEntrada">Registrar Flujo de Caseta</router-link></b-dropdown-item>
    <b-dropdown-item><router-link to="/ActualizarFoto">Actualizar Foto de Persona</router-link></b-dropdown-item>

    
    
  </b-dropdown>
   </div>
</template>

<script>

import axios from 'axios'


export default {
    name:'Menu',
    
    methods:{
        
        
    }

}

</script>


// WEBPACK FOOTER //
// src/components/Menu.vue